import React, { ReactElement, useContext, useEffect } from 'react';
import { FieldRendererProps } from '../FieldTableTypes';
import { FieldTableSettingsContext } from '../../../contexts/field-table-settings-context';
import {TextField} from "@mui/material";


export function FieldTableSelectColumn(): ReactElement {
    // kindof weird, this never gets used?
    const context = useContext(FieldTableSettingsContext);
    useEffect(() => {
        context.registerType({
            dataType: 'select',
            width: () => 'minmax(10em,auto)',
            className: () => '',
            renderViewer: (props: FieldRendererProps<any,any>) => {
                let value = props.options?.getValue ? props.options.getValue(props) : props.field.value;
                if(value && props.options?.label) { value = value[props.options.label]; }
                return value;
            },
            renderEditor: (props: FieldRendererProps<any,any>) => {
                const value = props.options?.getValue ? props.options.getValue(props) : props.field.value;
                return (<TextField {...(props.field as any)} value={value} autoFocus={true} />);
            },
            renderExport:(cell,props: FieldRendererProps<any,any>):any => {
                let value = props.options?.getValue ? props.options.getValue(props) : props.field.value;
                if(props.options?.label && value) {
                    value = value[props.options.label];
                }
                if (typeof value == 'object') {
                    if (value) {
                        value = value.toString();
                        cell.v = value;
                    } else {
                        cell.v = '';
                    }
                }
                else {
                    cell.v = value;
                }
                return cell;
            }
        });
    }, [context]);
    return null;
}
